// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: Ckr77byyGn3q
import * as React from "react";
import {
  Stack as Stack__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import InvoiceItem from "../../InvoiceItem"; // plasmic-import: -fR3b8VmLe9a/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicCurrentInvoicePaymentsPageCard.module.css"; // plasmic-import: Ckr77byyGn3q/css
import Line2Icon from "./icons/PlasmicIcon__Line2"; // plasmic-import: pAewef34g4ck/icon

createPlasmicElementProxy;

export const PlasmicCurrentInvoicePaymentsPageCard__VariantProps = new Array();

export const PlasmicCurrentInvoicePaymentsPageCard__ArgProps = new Array(
  "invoiceNumber",
  "sidebarAmount",
  "merchantName",
  "amount",
  "dueDate"
);

const $$ = {};

function PlasmicCurrentInvoicePaymentsPageCard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            projectcss.plasmic_tokens,
            plasmic_antd_5_hostless_css.plasmic_tokens,
            sty.root
          )}
        >
          <div
            data-plasmic-name={"previewBody"}
            data-plasmic-override={overrides.previewBody}
            className={classNames(projectcss.all, sty.previewBody)}
          >
            <div className={classNames(projectcss.all, sty.freeBox___9ZrbB)}>
              <div
                data-plasmic-name={"companyName"}
                data-plasmic-override={overrides.companyName}
                className={classNames(projectcss.all, sty.companyName)}
              >
                {renderPlasmicSlot({
                  defaultContents: "Pulsebound",
                  value: args.merchantName,
                  className: classNames(sty.slotTargetMerchantName)
                })}
              </div>
              <div
                data-plasmic-name={"rectangle29"}
                data-plasmic-override={overrides.rectangle29}
                className={classNames(projectcss.all, sty.rectangle29)}
              >
                <div
                  data-plasmic-name={"figmaPaste"}
                  data-plasmic-override={overrides.figmaPaste}
                  className={classNames(projectcss.all, sty.figmaPaste)}
                >
                  <div
                    className={classNames(projectcss.all, sty.freeBox__mM7Be)}
                  >
                    <div
                      className={classNames(projectcss.all, sty.freeBox__unyhH)}
                    >
                      {renderPlasmicSlot({
                        defaultContents: "$300.00 ",
                        value: args.amount,
                        className: classNames(sty.slotTargetAmount)
                      })}
                    </div>
                    <div
                      className={classNames(projectcss.all, sty.freeBox__dDoFs)}
                    >
                      {renderPlasmicSlot({
                        defaultContents: "due on July 21, 2022",
                        value: args.dueDate,
                        className: classNames(sty.slotTargetDueDate)
                      })}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"viewDetails"}
                    data-plasmic-override={overrides.viewDetails}
                    className={classNames(
                      projectcss.all,
                      projectcss.__wab_text,
                      sty.viewDetails
                    )}
                  >
                    {"View Invoice Details  >"}
                  </div>
                  <Line2Icon
                    data-plasmic-name={"svg"}
                    data-plasmic-override={overrides.svg}
                    className={classNames(projectcss.all, sty.svg)}
                    role={"img"}
                  />

                  <button
                    data-plasmic-name={"handleCardPayment"}
                    data-plasmic-override={overrides.handleCardPayment}
                    className={classNames(
                      projectcss.all,
                      projectcss.button,
                      sty.handleCardPayment
                    )}
                    ref={ref => {
                      $refs["handleCardPayment"] = ref;
                    }}
                  >
                    <div
                      className={classNames(
                        projectcss.all,
                        projectcss.__wab_text,
                        sty.text__mhS09
                      )}
                    >
                      {"Pay with your card"}
                    </div>
                  </button>
                </div>
              </div>
              <div
                data-plasmic-name={"figmaPaste3"}
                data-plasmic-override={overrides.figmaPaste3}
                className={classNames(projectcss.all, sty.figmaPaste3)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__evZtS
                  )}
                >
                  {"Powered by astrius"}
                </div>
              </div>
            </div>
            <div
              data-plasmic-name={"sideBarInstance"}
              data-plasmic-override={overrides.sideBarInstance}
              className={classNames(projectcss.all, sty.sideBarInstance)}
            >
              <div className={classNames(projectcss.all, sty.freeBox__fMbaJ)}>
                <div
                  data-plasmic-name={"closeButton"}
                  data-plasmic-override={overrides.closeButton}
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.closeButton
                  )}
                >
                  {"X"}
                </div>
                <div
                  data-plasmic-name={"closeButton2"}
                  data-plasmic-override={overrides.closeButton2}
                  className={classNames(projectcss.all, sty.closeButton2)}
                >
                  {renderPlasmicSlot({
                    defaultContents: "Invoice #12",
                    value: args.invoiceNumber,
                    className: classNames(sty.slotTargetInvoiceNumber)
                  })}
                </div>
                <div className={classNames(projectcss.all, sty.freeBox__tkwIu)}>
                  {renderPlasmicSlot({
                    defaultContents: (
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__mN94Q
                        )}
                      >
                        {"$300.00"}
                      </div>
                    ),

                    value: args.sidebarAmount,
                    className: classNames(sty.slotTargetSidebarAmount)
                  })}
                </div>
              </div>
              <Stack__
                as={"div"}
                data-plasmic-name={"invoiceItemStack"}
                data-plasmic-override={overrides.invoiceItemStack}
                hasGap={true}
                className={classNames(projectcss.all, sty.invoiceItemStack)}
              >
                <InvoiceItem
                  data-plasmic-name={"invoiceItem"}
                  data-plasmic-override={overrides.invoiceItem}
                  className={classNames("__wab_instance", sty.invoiceItem)}
                  item={"Social Media Management"}
                />
              </Stack__>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "svg",
    "handleCardPayment",
    "figmaPaste3",
    "sideBarInstance",
    "closeButton",
    "closeButton2",
    "invoiceItemStack",
    "invoiceItem"
  ],

  previewBody: [
    "previewBody",
    "companyName",
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "svg",
    "handleCardPayment",
    "figmaPaste3",
    "sideBarInstance",
    "closeButton",
    "closeButton2",
    "invoiceItemStack",
    "invoiceItem"
  ],

  companyName: ["companyName"],
  rectangle29: [
    "rectangle29",
    "figmaPaste",
    "viewDetails",
    "svg",
    "handleCardPayment"
  ],

  figmaPaste: ["figmaPaste", "viewDetails", "svg", "handleCardPayment"],
  viewDetails: ["viewDetails"],
  svg: ["svg"],
  handleCardPayment: ["handleCardPayment"],
  figmaPaste3: ["figmaPaste3"],
  sideBarInstance: [
    "sideBarInstance",
    "closeButton",
    "closeButton2",
    "invoiceItemStack",
    "invoiceItem"
  ],

  closeButton: ["closeButton"],
  closeButton2: ["closeButton2"],
  invoiceItemStack: ["invoiceItemStack", "invoiceItem"],
  invoiceItem: ["invoiceItem"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCurrentInvoicePaymentsPageCard__ArgProps,
          internalVariantPropNames:
            PlasmicCurrentInvoicePaymentsPageCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCurrentInvoicePaymentsPageCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCurrentInvoicePaymentsPageCard";
  } else {
    func.displayName = `PlasmicCurrentInvoicePaymentsPageCard.${nodeName}`;
  }
  return func;
}

export const PlasmicCurrentInvoicePaymentsPageCard = Object.assign(
  // Top-level PlasmicCurrentInvoicePaymentsPageCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    previewBody: makeNodeComponent("previewBody"),
    companyName: makeNodeComponent("companyName"),
    rectangle29: makeNodeComponent("rectangle29"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    viewDetails: makeNodeComponent("viewDetails"),
    svg: makeNodeComponent("svg"),
    handleCardPayment: makeNodeComponent("handleCardPayment"),
    figmaPaste3: makeNodeComponent("figmaPaste3"),
    sideBarInstance: makeNodeComponent("sideBarInstance"),
    closeButton: makeNodeComponent("closeButton"),
    closeButton2: makeNodeComponent("closeButton2"),
    invoiceItemStack: makeNodeComponent("invoiceItemStack"),
    invoiceItem: makeNodeComponent("invoiceItem"),
    // Metadata about props expected for PlasmicCurrentInvoicePaymentsPageCard
    internalVariantProps: PlasmicCurrentInvoicePaymentsPageCard__VariantProps,
    internalArgProps: PlasmicCurrentInvoicePaymentsPageCard__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicCurrentInvoicePaymentsPageCard;
/* prettier-ignore-end */
